import { render, staticRenderFns } from "./CreateRecessDialog.vue?vue&type=template&id=bb5185f6&scoped=true"
import script from "@/views/RosterTemplates/CreateRecessDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/RosterTemplates/CreateRecessDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/RosterTemplates/create-recess-dialog.scss?vue&type=style&index=0&id=bb5185f6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5185f6",
  null
  
)

export default component.exports